import { Proposal } from '../models/Proposal';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface ProposalState extends ApiState {
  proposals?: Proposal[]
}

export default requestReducer<ProposalState>('PROPOSAL_LIST')